module.exports = __webpack_public_path__ + "img/nolive.9b4903b1.png";